import React, { useEffect } from "react";
import Button from "../../Components/Button";
import ImageSlider from "../../Components/ImageSlider";
import { normalizeColor, getContrastTextColor } from "../../Constant/colors";
import { SearchNormal1 } from "iconsax-react";
import { QrCodeIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { loadGoogleFont } from "../../Constant/fontLoader";
import { formatTo12Hour } from "../../Constant/time";

const EventPreviewContent = ({ eventInfo, customizations, view }) => {
  const theme_color = normalizeColor(customizations.theme_color || "#000000");

  const formatFontName = (fontName) => {
    if (!fontName || fontName === "inherit") return "inherit";
    return fontName
      .split("-")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const title_font = formatFontName(customizations.title_font) || "inherit";
  const content_font = formatFontName(customizations.content_font) || "inherit";
  const disableStyle = { pointerEvents: "none" };

  const responsiveWidth = {
    monitor: "w-[1024px]",
    tablet: "w-[768px]",
    mobile: "w-[425px]",
  };

  useEffect(() => {
    if (title_font && title_font !== "inherit") {
      loadGoogleFont(title_font);
    }
    if (content_font && content_font !== "inherit") {
      loadGoogleFont(content_font);
    }
  }, [title_font, content_font]);

  return (
    <div className="flex justify-center py-6">
      <div
        className={`flex flex-col lg:flex-row bg-gray-50 shadow-md overflow-hidden ${
          responsiveWidth[view] || "w-[1024px]"
        }`}
        style={{ minHeight: "600px" }}
      >
        {view === "monitor" && (
          <div className="relative w-3/5 h-[600px]">
            <ImageSlider
              imageList={eventInfo.image}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            <Button
              variant="secondary"
              className="absolute top-4 left-4 shadow-lg text-[10px]"
              style={disableStyle}
            >
              <XMarkIcon className="size-[11px]" />
              Exit Page
            </Button>
          </div>
        )}

        <div
          className={`flex flex-col justify-center items-center gap-6 overflow-y-auto ${
            view === "mobile"
              ? "w-full px-4 py-6"
              : view === "tablet"
              ? "w-full px-10 py-10"
              : "w-full lg:w-2/5 px-10 py-10"
          }`}
          style={{
            backgroundColor: customizations.image ? "transparent" : "white",
            backgroundImage: customizations.image
              ? `url(${customizations.image})`
              : null,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            color: customizations?.theme_color || "#000000",
          }}
        >
          <div className="flex flex-col items-center text-center gap-2">
            <h2
              className={`font-normal ${
                view === "mobile"
                  ? "text-[14px]"
                  : view === "tablet"
                  ? "text-[14px]"
                  : "text-[14px]"
              }`}
            >
              - Welcome to -
            </h2>
            <h1
              className={`font-bold leading-snug ${
                view === "mobile"
                  ? "text-[38.4px]"
                  : view === "tablet"
                  ? "text-[38.4px]"
                  : "text-[56px]"
              }`}
              style={{ fontFamily: title_font }}
            >
              {eventInfo.name}
            </h1>
          </div>

          <div className="flex flex-col items-center text-center gap-1.5">
            <div className="flex flex-col gap-0">
              <h2 className="text-[19px] font-semibold">
                {new Date(eventInfo.date).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </h2>
              <h3 className="text-[11px] font-medium">
                {formatTo12Hour(eventInfo.time)}
              </h3>
            </div>
            <div className="border-2 w-6" />
            <p className="text-[10px]">{eventInfo.venue}</p>
          </div>

          <div
            className="flex flex-col items-center gap-3 w-full max-w-[320px]"
            style={{ marginTop: "8px" }}
          >
            <Button
              variant="custom"
              className={`w-full border border-[#EFF0F2] text-[#C1C4CB] rounded-lg justify-start font-normal h-10 ${
                view === "mobile"
                  ? "text-[11px]"
                  : view === "tablet"
                  ? "text-[11px]"
                  : "text-[11px]"
              }`}
              style={disableStyle}
            >
              <SearchNormal1 size={12} />
              Search
            </Button>

            {view === "mobile" || view === "tablet" ? (
              <>
                <Button
                  variant="secondary"
                  className="w-full h-10 text-[11px]"
                  style={disableStyle}
                >
                  Add Walk-In Guest
                </Button>
                <Button
                  variant="custom"
                  className="w-full h-10 flex items-center justify-center gap-2 text-[11px]"
                  style={{
                    ...disableStyle,
                    backgroundColor: theme_color,
                    color: getContrastTextColor(theme_color),
                  }}
                >
                  <QrCodeIcon className="size-[14px]" />
                  Scan QR Code
                </Button>
              </>
            ) : (
              <div className="grid grid-cols-2 gap-3 w-full">
                <Button
                  variant="secondary"
                  className="h-10 text-[11px]"
                  style={disableStyle}
                >
                  Add Walk-In Guest
                </Button>
                <Button
                  variant="custom"
                  className="h-10 flex items-center justify-center gap-2 text-[11px]"
                  style={{
                    ...disableStyle,
                    backgroundColor: theme_color,
                    color: getContrastTextColor(theme_color),
                  }}
                >
                  <QrCodeIcon className="size-[14px]" />
                  Scan QR Code
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventPreviewContent;
